import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
const team = [{
  name: 'Matt Danilowicz',
  role: 'Chief Executive',
  domains: ['Media Tech', 'AI Startups', 'Mortgage Finance', 'Manufacturing', 'Board Advisory'],
  accent: 'from-amber/20 to-amber/5 border-amber/40',
  dot: 'bg-amber',
  href: '/people/matt-danilowicz'
}, {
  name: 'Janet Cooke',
  role: 'Founder-Practitioner, Results by Design',
  domains: ['Energy', 'SaaS', 'Non-Profits', 'Leadership Development'],
  accent: 'from-sky-400/20 to-sky-400/5 border-sky-400/40',
  dot: 'bg-sky-400',
  href: 'https://www.janetcookeconsulting.com',
  external: true
}, {
  name: 'Craig Dwyer',
  role: 'CEO, Lunex',
  domains: ['AI Content Creation', 'Product Design & Development', 'Workflow Optimization'],
  accent: 'from-emerald-400/20 to-emerald-400/5 border-emerald-400/40',
  dot: 'bg-emerald-400',
  href: 'https://www.lunex.one',
  external: true
}, {
  name: 'Sara Cramlet',
  role: 'Founder, Success Creation',
  domains: ['Healthcare', 'Education', 'Finance', 'Senior Professional in Human Resources (SPHR)'],
  accent: 'from-rose-400/20 to-rose-400/5 border-rose-400/40',
  dot: 'bg-rose-400',
  href: 'https://successcreationllc.com',
  external: true
}];
export function OurPeople() {
  return <section id="our-people" className="pt-12 pb-24 md:pt-16 md:pb-32 bg-navy-light/50 border-y border-white/5" data-id="element-117">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-118">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-119">
          <motion.div className="lg:col-span-5" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-120">
            <p className="text-sm font-medium tracking-wider uppercase text-amber mb-4" data-id="element-121">
              Our People
            </p>
            <h2 className="text-4xl md:text-5xl font-serif text-offwhite leading-tight" data-id="element-122">
              Your transition,{' '}
              <span className="italic text-amber" data-id="element-123">our full attention</span>.
            </h2>
          </motion.div>

          <motion.div className="lg:col-span-7 lg:pt-4" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} data-id="element-124">
            <p className="text-lg text-offwhite font-light leading-relaxed mb-6" data-id="element-125">
              Cognisensus comprises former C-level executives and management
              consultants with backgrounds spanning{' '}
              <span className="text-amber" data-id="element-126">
                technology, finance, media content creation, manufacturing,
                healthcare, and education
              </span>
              .
            </p>
            <p className="text-lg text-offwhite-muted font-light leading-relaxed" data-id="element-127">
              We approach transformation as a{' '}
              <span className="text-offwhite italic" data-id="element-128">
                leadership architecture
              </span>{' '}
              challenge — not just a technology deployment exercise.
            </p>
          </motion.div>
        </div>

        {/* Team cards */}
        <motion.ul className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5" initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} variants={{
        hidden: {
          opacity: 0
        },
        visible: {
          opacity: 1,
          transition: {
            staggerChildren: 0.08
          }
        }
      }} data-id="element-129">
          {team.map(person => {
          const CardInner = <>
                <div className="flex items-center gap-2 mb-5" data-id="element-130">
                  <span className={`w-2 h-2 rounded-full ${person.dot}`} aria-hidden="true" data-id="element-131" />
                  <span className="text-[0.7rem] font-medium tracking-[0.2em] uppercase text-offwhite-muted" data-id="element-132">
                    Partner
                  </span>
                </div>

                <h3 className="text-2xl font-serif text-offwhite leading-tight mb-2" data-id="element-133">
                  {person.name}
                </h3>
                <p className="text-sm text-offwhite-muted font-light leading-snug mb-5" data-id="element-134">
                  {person.role}
                </p>

                <div className="mt-auto flex flex-wrap gap-1.5" data-id="element-135">
                  {person.domains.map(d => <span key={d} className="text-[0.7rem] font-medium tracking-wide uppercase text-offwhite/80 bg-navy/40 border border-white/10 rounded-sm px-2 py-1" data-id="element-136">
                      {d}
                    </span>)}
                </div>

                {person.href && <div className="mt-5 flex items-center gap-1.5 text-xs font-medium tracking-wider uppercase text-offwhite-muted group-hover:text-amber transition-colors" data-id="element-137">
                    {person.external ? 'Visit site' : 'View bio'}
                    <ArrowUpRight size={14} className="group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform" data-id="element-138" />
                  </div>}
              </>;
          const baseClass = `group relative flex flex-col h-full p-6 md:p-7 rounded-md border bg-gradient-to-br ${person.accent} backdrop-blur-sm transition-all`;
          const interactiveClass = person.href ? ' hover:-translate-y-0.5 hover:shadow-lg' : '';
          return <motion.li key={person.name} variants={{
            hidden: {
              opacity: 0,
              y: 16
            },
            visible: {
              opacity: 1,
              y: 0,
              transition: {
                duration: 0.5,
                ease: 'easeOut'
              }
            }
          }} data-id="element-139">
                {person.href ? person.external ? <a href={person.href} target="_blank" rel="noopener noreferrer" className={baseClass + interactiveClass} data-id="element-140">
                      {CardInner}
                    </a> : <Link to={person.href} className={baseClass + interactiveClass} data-id="element-141">
                      {CardInner}
                    </Link> : <div className={baseClass} data-id="element-142">{CardInner}</div>}
              </motion.li>;
        })}
        </motion.ul>
      </div>
    </section>;
}